module.exports = __webpack_public_path__ + "img/fondo_retiro.9f88531e.png";